// Local url of a picked file, for the preview. Revoke it when it is not shown anymore.
const getPathFile = (file: File) => {
  if (window.URL) {
    return window.URL.createObjectURL(file);
  }
  if (window.webkitURL) {
    return window.webkitURL.createObjectURL(file);
  }
  return '';
};

const revokePathFile = (path: string) => {
  if (path && window.URL) {
    window.URL.revokeObjectURL(path);
  }
};

// Duration in seconds, read from the file metadata only (the file is not loaded).
const getVideoDuration = (file: File) => new Promise<number>((resolve, reject) => {
  const path = getPathFile(file);
  const video = document.createElement('video');
  video.preload = 'metadata';
  video.onloadedmetadata = () => {
    revokePathFile(path);
    resolve(video.duration);
  };
  video.onerror = () => {
    revokePathFile(path);
    reject(new Error('Unreadable video'));
  };
  video.src = path;
});

export {
  getPathFile,
  getVideoDuration,
  revokePathFile,
};
